import { useEffect } from 'react';
const useNativeEventListener = (callback) => {
    useEffect(() => {
        window?.addEventListener('message', callback); // ios
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document?.addEventListener('message', callback); // android
        return () => {
            window?.removeEventListener('message', callback); // ios
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            document?.removeEventListener('message', callback); // android
        };
    }, [callback]);
};
const parseJSON = (data) => {
    try {
        return JSON.parse(data);
    }
    catch (e) {
        return undefined;
    }
};
export const parseCallback = (data) => {
    if (typeof data === 'string') {
        return parseJSON(data);
    }
    return data;
};
export default useNativeEventListener;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTmF0aXZlRXZlbnRMaXN0ZW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL21vYmlsYmFuay1saWIvc3JjL3VzZU5hdGl2ZUV2ZW50TGlzdGVuZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQVFsQyxNQUFNLHNCQUFzQixHQUFHLENBQzNCLFFBQW1ELEVBQy9DLEVBQUU7SUFDTixTQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsTUFBTSxFQUFFLGdCQUFnQixDQUFDLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDLE1BQU07UUFDckQsNkRBQTZEO1FBQzdELGFBQWE7UUFDYixRQUFRLEVBQUUsZ0JBQWdCLENBQUMsU0FBUyxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsVUFBVTtRQUMzRCxPQUFPLEdBQUcsRUFBRTtZQUNSLE1BQU0sRUFBRSxtQkFBbUIsQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQyxNQUFNO1lBQ3hELDZEQUE2RDtZQUM3RCxhQUFhO1lBQ2IsUUFBUSxFQUFFLG1CQUFtQixDQUFDLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDLFVBQVU7UUFDbEUsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQztBQUNuQixDQUFDLENBQUM7QUFFRixNQUFNLFNBQVMsR0FBRyxDQUEwQyxJQUFhLEVBQXNDLEVBQUU7SUFDN0csSUFBSSxDQUFDO1FBQ0QsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUssQ0FBMkIsQ0FBQztJQUN2RCxDQUFDO0lBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztRQUNULE9BQU8sU0FBUyxDQUFDO0lBQ3JCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsQ0FDekIsSUFBcUMsRUFDSCxFQUFFO0lBQ3BDLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDM0IsT0FBTyxTQUFTLENBQVMsSUFBSSxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUNELE9BQU8sSUFBSSxDQUFDO0FBQ2hCLENBQUMsQ0FBQztBQUVGLGVBQWUsc0JBQXNCLENBQUMifQ==